import {MessageActionTypes} from 'components/Messages/types'

export type UserInfoProps = {
    channelId?: string
    light?: boolean;
    size?: 'big' | 'mid';
    userId: string;
}
export type UserDetails = {
    company?: string
    jobTitle?: string
    websiteUrl?: string
    name: string
    iconURL?: string
}

export type UserInfoViewProps = UserDetails & {
    light?: boolean;
    size?: 'big' | 'mid';
    userId: string;
    autohide?: boolean
    canAddToOrganization: boolean
    moderator?: boolean
    operator?: boolean
    silenced?: boolean
    canChangeRights: boolean
    canModerate: boolean
    disableRemoveOperator: boolean

    handleChannelAction: (action: MessageActionTypes) => () => void
    loadDialogue: (dialogue_id: string) => void
    onAddToOrganization: () => void
    toggleRights: (right: UserRights, state: boolean) => void
    translations: {
        addToOrganization: string
        externalLink: string
        for15Minutes: string
        for1Hour: string
        for24Hours: string
        for5Minutes: string
        giveModerationRights: string
        giveOperatorRights: string
        hideAllMessages: string
        hideNewMessages: string
        moderator: string
        operator: string
        removeModerationRights: string
        removeOperatorRights: string
        removeUserFromChannel: string
        showNewMessages: string
        silenceUser: string
        startPrivateConversation: string
        unsilenceUser: string
        untilUnsilenced: string
    }
}

export enum UserRights {
    operator = 'operator',
    moderator = 'moderator'
}
